import LegalLayout, { LegalSection } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026" testid="privacy-page">
      <p className="mt-6 text-sm text-muted-foreground leading-relaxed">
        Houses7.com ("we", "us") operates this property marketplace. This policy explains what personal
        information we collect, why we collect it and the choices you have. By using Houses7.com you agree to
        this policy.
      </p>

      <LegalSection title="1. Information we collect">
        <p>
          <b>Account details</b> — your name, email address, mobile number, password (stored only as a secure
          one-way hash) and, if you sign in with Google, the basic profile Google shares with us.
        </p>
        <p>
          <b>Listing details</b> — everything you enter about a property you list, including photographs,
          address, price and the contact number you want buyers to see.
        </p>
        <p>
          <b>Enquiries</b> — when you contact an owner or dealer we pass on your name, phone number, email and
          message so they can respond.
        </p>
        <p>
          <b>PG / rental management data</b> — if you use the stay or rentals module, tenant names, contact
          numbers, rent amounts and payment records you record there.
        </p>
        <p>
          <b>Technical data</b> — IP address, browser and device information, and the pages you visit. We use
          this for security (device and login-alert tracking) and to improve the product.
        </p>
      </LegalSection>

      <LegalSection title="2. How we use your information">
        <p>To create and secure your account, publish your listings and deliver enquiries to the right owner.</p>
        <p>
          To send service emails you have asked for: enquiry notifications, property alerts you subscribed to,
          rent reminders and receipts, login alerts for new devices, and the one-time codes used to verify your
          email or mobile number.
        </p>
        <p>To detect and prevent fraud, spam, duplicate listings and abuse of the platform.</p>
        <p>We do not sell your personal information to anyone.</p>
      </LegalSection>

      <LegalSection title="3. What is visible to others">
        <p>
          A published listing is public. The contact name and number you enter on a listing are shown to buyers
          so they can reach you. Your email address and password are never shown publicly.
        </p>
        <p>
          When you submit an enquiry, your name, phone number, email and message are shared with that property's
          owner or dealer, and with Houses7 administrators.
        </p>
      </LegalSection>

      <LegalSection title="4. Cookies and similar technology">
        <p>
          We use cookies strictly to keep you signed in and to protect your session. We do not use third-party
          advertising cookies. Blocking cookies will stop you from logging in.
        </p>
      </LegalSection>

      <LegalSection title="5. Service providers">
        <p>
          We rely on a small number of processors to run the service: our cloud hosting and database provider,
          Google Firebase for authentication, an email delivery provider for the emails described above, and
          OpenStreetMap for maps. They may only process your data on our instructions.
        </p>
      </LegalSection>

      <LegalSection title="6. How long we keep data">
        <p>
          Account and listing data is kept while your account is active. Enquiries are retained so owners have a
          record of their leads. When you ask us to delete your account we remove your personal details and
          unpublish your listings, keeping only what the law requires us to keep.
        </p>
      </LegalSection>

      <LegalSection title="7. Your rights">
        <p>
          You can view and correct your details any time from Dashboard → Account, change your password, see and
          sign out of other devices, unsubscribe from property alerts using the link in any alert email, and
          delete your own listings.
        </p>
        <p>
          To request a copy of your data or full deletion of your account, email hello@houses7.com from your
          registered address.
        </p>
      </LegalSection>

      <LegalSection title="8. Security">
        <p>
          Traffic is encrypted over HTTPS, passwords are hashed, sessions are device-tracked and we rate-limit
          logins to block brute-force attempts. No online service can promise perfect security, so please use a
          strong, unique password.
        </p>
      </LegalSection>

      <LegalSection title="9. Children">
        <p>Houses7.com is not intended for anyone under 18 years of age.</p>
      </LegalSection>

      <LegalSection title="10. Changes to this policy">
        <p>
          If we make a material change we will update the date at the top of this page and, where appropriate,
          notify you by email.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
